import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-loading-message',
    templateUrl: './loading-message.component.html',
    styleUrls: ['./loading-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class LoadingMessageComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
